const config = {
  REACT_APP_HOST_API_AUTENTICACAO: process.env.REACT_APP_HOST_API_AUTENTICACAO,
  REACT_APP_HOST_API_EMPRESAS: process.env.REACT_APP_HOST_API_EMPRESAS,
  REACT_APP_HOST_API_ESOCIAL: process.env.REACT_APP_HOST_API_ESOCIAL,
  REACT_APP_HOST_API_CONCILIACAO: process.env.REACT_APP_HOST_API_CONCILIACAO,
  REACT_APP_HOST_API_FINANCEIRO: process.env.REACT_APP_HOST_API_FINANCEIRO,
  REACT_APP_HOST_API_INTEGRACAO_OPENAI:
    process.env.REACT_APP_HOST_API_INTEGRACAO_OPENAI,
};

export default config;
